import { GeneratedSuggestions } from '../../../@types/generate-suggestion-types'
import { InitState } from '../../reducers/root/initialState'
import { getDefaultLogger } from '../../../services/logger/logger'

export const AI_TEXT_LOG_PREFIX = 'AI_TEXT_INVESTIGATION'
export const AI_TEXT_REQUEST_ID_HEADER = 'X-CLF-AI-Text-Investigation-Request-Id'
export const AI_TEXT_LISTING_SESSION_ID_HEADER = 'X-CLF-Listing-Session-Id'

function getTextLength(value?: string) {
  return value?.length ?? 0
}

export function getAiTextLogContext(state: InitState) {
  const insertionFeature = state.insertionFeature ?? {}
  const suggestedTextFeature = state.suggestedTextFeature ?? {}
  const insertionIdentification = insertionFeature.insertionIdentification ?? {}
  const insertionData = insertionFeature.insertionData ?? {}
  const changeVersion = insertionFeature.changeVersion
  const save = insertionFeature.save
  const activeRequestId = suggestedTextFeature.activeRequestId
  const activeRequestSourceVersion = suggestedTextFeature.activeRequestSourceVersion
  const lastCompletedRequestId = suggestedTextFeature.lastCompletedRequestId
  const isTitleManuallyEdited = suggestedTextFeature.isTitleManuallyEdited
  const isDescriptionManuallyEdited = suggestedTextFeature.isDescriptionManuallyEdited
  const isLocationManuallyEdited = suggestedTextFeature.isLocationManuallyEdited

  return {
    listingSessionId: insertionIdentification.id,
    realEstateId: insertionIdentification.realEstateId,
    changeVersion,
    saveStatus: save,
    activeRequestId,
    activeRequestSourceVersion,
    lastCompletedRequestId,
    manualFlags: {
      title: isTitleManuallyEdited,
      description: isDescriptionManuallyEdited,
      location: isLocationManuallyEdited,
    },
    currentFieldLengths: {
      adTitle: getTextLength(insertionData.adTitle),
      adDescription: getTextLength(insertionData.adDescription),
      adLocation: getTextLength(insertionData.adLocation),
    },
  }
}

export function getSuggestionSummary(suggestions: GeneratedSuggestions) {
  return {
    titleLength: getTextLength(suggestions.title),
    descriptionLength: getTextLength(suggestions.description),
    locationLength: getTextLength(suggestions.location),
    hasTitle: Boolean(suggestions.title),
    hasDescription: Boolean(suggestions.description),
    hasLocation: Boolean(suggestions.location),
  }
}

export function logAiTextInvestigation(event: string, payload: Record<string, unknown> = {}) {
  getDefaultLogger().info?.(`${AI_TEXT_LOG_PREFIX} ${event}`, {
    event,
    ...payload,
  })
}
